<template>
  <div class="result-voting">
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">議題主</span>
      </div>
      <input type="text" class="form-control" :value="themeUser.name">
    </div>
    <div class="card">
      <div class="card-header">
        勝者
      </div>
      <div class="card-body">
        <ul class="list-group list-group-flush">
          <li class="list-group-item" v-for="winer in winers" :key="winer.uid">{{ members.find(member => member.uid === winer.uid).name }}</li>
        </ul>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>プレイヤー名</th>
          <th>獲得票</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="member in members" :key="member.uid">
          <td>{{ member.name }}</td>
          <td>{{ voteResults[member.uid] }}</td>
        </tr>
      </tbody>
    </table>
    <!-- <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">最も票を集めたプレイヤー</span>
      </div>
      <input type="text" class="form-control" :value="votedUser.name">
    </div> -->
  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  name: 'ResultVoting',
  props: {
    isOwner: Boolean,
    members: { type: Array }
  },
  data() {
    return {
      db: null,
      votes: [],
      theme: null,
      themeUser: {name: ''},
      // votedUser: {name: ''},
      voteResults: [],
      // points: [],
      // isOwner: Boolean,
      winers: []
    }
  },
  methods: {
    getThemeUser() {
      this.themeUser = this.members.find(member => member.uid === this.theme.uid);
    },
    // getVotedUser() {
    //   // 議題主の票を削除
    //   const vue = this;
    //   const votes = this.votes.filter(function(vote) {
    //     return (vote.from !== vue.themeUser.uid);
    //   });
    //
    //   // 票をカウント
    //   let resultVoting = {};
    //   votes.forEach(vote=>{
    //     if (resultVoting[vote.to] === undefined){
    //       resultVoting[vote.to] = 1;
    //     }else{
    //       resultVoting[vote.to]++;
    //     }
    //   });
    //   this.voteResults = resultVoting;

      // 最も表の多いuserを取得
      // const resultNumbers = Object.entries(resultVoting).map(([uid, value]) => ({uid, value}));
      // let max = {value: 0, uid: null};
      // for (let i = 0; i < resultNumbers.length; i++){
      //   if (max.value < resultNumbers[i].value){
      //     max.value = resultNumbers[i].value;
      //     max.uid = resultNumbers[i].uid;
      //   }
      // }
      //
      // this.votedUser = this.members.find(member => member.uid === max.uid);
    // },
    getVoteResults() {
      // 議題主の票を削除
      const vue = this;
      const votes = this.votes.filter(function(vote) {
        return (vote.from !== vue.themeUser.uid);
      });

      // 票をカウント
      let resultVoting = {};
      votes.forEach(vote=>{
        if (resultVoting[vote.to] === undefined){
          resultVoting[vote.to] = 1;
        }else{
          resultVoting[vote.to]++;
        }
      });
      this.voteResults = resultVoting;
    },
    // changePoint() {
    //   let add = 0;
    //   if (this.themeUser.uid === this.votedUser.uid){
    //     add = 1;
    //   }else {
    //     add = 2;
    //   }
    //
    //   let votedUserPoint = 0;
    //   if (this.points[this.votedUser.uid] !== undefined){
    //     votedUserPoint = this.points[this.votedUser.uid];
    //   }
    //
    //   const key = 'points.' + this.votedUser.uid;
    //   const value = votedUserPoint + add;
    //   this.db.collection('rooms').doc(this.$route.params.room_id).update({
    //     [key]: value
    //   });
    // }
    getWiners() {
      // それぞれのポイントを求める
      let max = {point: 0, users: []}
      Object.keys(this.voteResults).forEach((uid) => {
        // ポイントを計算
        let point = 0;
        if (uid === this.themeUser.uid){
          point = this.voteResults[uid];
        }else {
          point = this.voteResults[uid] * 2;
        }

        // 現在の最大ポイントより大きい
        if (max.point < point){
          max.point = point;
          max.users = [{uid}];
        }
        else if (max.point === point){
          max.users.push({uid});
        }
      });

      this.winers = max.users;
    }
  },
  created() {
    this.db = firebase.firestore();
    this.db.collection('rooms').doc(this.$route.params.room_id).get().then(doc=>{
      const data = doc.data();
      this.votes = data.votes;
      this.theme = data.theme;
      // this.points = data.points;

      this.getThemeUser();
      // this.getVotedUser();
      this.getVoteResults();
      this.getWiners();

      if (this.isOwner){
        this.$emit('send-system-message', 'お題主は「' + this.themeUser.name + "」です。");
      }

      // if (this.isOwner){
      //   // this.changePoint();
      // }
    });
  }
}
</script>
<style scoped>
</style>
